import React from "react";
import WaterCoolerComments from "./WaterCoolerComments/WaterCoolerComments";
import { useWaterCoolerContext } from "store/contexts/waterCoolerContext";
import WaterCoolerMemberStatus from "./WaterCoolerMemberStatus";

export default function () {
  const { allMessages } = useWaterCoolerContext();

  return (
    <>
      {allMessages.map((message, key) => (
        <div key={key}>
          {!message.status && <WaterCoolerComments message={message} />}
          {message.status && <WaterCoolerMemberStatus message={message} />}
        </div>
      ))}
    </>
  );
}
